document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".carousel-slide");
  const dots = document.querySelectorAll(".dot");
  let curSlide = 0;
  let loop;

  slides.forEach((slide, i) => {
    slide.style.transform = `translateX(${(i - 0) * 100}%)`;
  });

  loop = setInterval(() => {
    curSlide = curSlide === slides.length - 1 ? 0 : curSlide + 1;

    slides.forEach((slide, i) => {
      slide.style.transform = `translateX(${(i - curSlide) * 100}%)`;
    });
    dots.forEach((dot) => {
      dot.classList.remove("active");
    });

    dots[curSlide].classList.add("active");
  }, 3000);

  dots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      clearInterval(loop);
      loop = null;
      curSlide = i;

      slides.forEach((slide, i) => {
        slide.style.transform = `translateX(${(i - curSlide) * 100}%)`;
      });
      dots.forEach((dot) => {
        dot.classList.remove("active");
      });

      dots[curSlide].classList.add("active");

      loop = setInterval(() => {
        curSlide = curSlide === slides.length - 1 ? 0 : curSlide + 1;

        slides.forEach((slide, i) => {
          slide.style.transform = `translateX(${(i - curSlide) * 100}%)`;
        });
        dots.forEach((dot) => {
          dot.classList.remove("active");
        });

        dots[curSlide].classList.add("active");
      }, 3000);
    });
  });
});
